.content {
  z-index: var(--z-popover);
  display: flex; align-items: center; gap: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border-radius: 8px;
  background: var(--color-text); color: var(--color-surface);
  font-size: var(--text-xs); font-weight: var(--weight-medium); line-height: var(--leading-tight);
  box-shadow: var(--shadow-2);
  transform-origin: var(--radix-tooltip-content-transform-origin);
  animation: in var(--duration-fast) var(--ease-out);
}
.content[data-state="instant-open"] { animation: none; }
.kbd { background: color-mix(in oklab, var(--color-surface) 18%, transparent); color: inherit; border-color: transparent; }
@keyframes in { from { opacity: 0; transform: scale(0.97); } }
